import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import 'sweetalert2/dist/sweetalert2.min.css'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import App from './App.vue'
import vmask from './plugins/v-mask'
import './plugins/vue-toast-notification.js'
import vuetify from './plugins/vuetify'
import './plugins/vuetify-money.js'
import router from './router'
import store from './store'
import socket from './plugins/socket'
import alertMonitor from './plugins/alert-monitor'
import { i18n } from './plugins/i18n'
import './plugins/axios'

Vue.use(VueSweetalert2)
Vue.use(alertMonitor)
Vue.config.productionTip = false
Vue.prototype.$socket = socket

new Vue({
  router,
  store,
  vuetify,
  vmask,
  i18n,
  render: h => h(App),
}).$mount('#app')
